  export const getImpersonateParamIfSuperuser = (firstParam=true) => {
    const impersonateUsername = localStorage.getItem("impersonateUsername");
    if(impersonateUsername){
      return `${firstParam ? '?':'&'}impersonateUsername=${impersonateUsername}`;
    }
    return '';
  };